import React, { ReactElement, useEffect, useMemo, useState } from 'react';
import LoadingApp from '../components-library/loading/LoadingApp';
import { AnimatePresence } from 'framer-motion';
import ConfigManager from '../services/api/ConfigManager';
import DomainResource from '../services/resources/DomainResource';
import { ConfigInterface } from '../services/exports/Interfaces';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../store/types';

interface Props {
  children: ReactElement;
}

export const LoadingContext = React.createContext(null);

const LoadingProvider = (props: Props): ReactElement => {
  const { children } = props;

  const { company } = useSelector((state: StoreInterface) => state.initialData);

  const [config, setConfig] = useState<ConfigInterface | null>(null);
  const [loading, setLoading] = useState(true);

  async function requestConfig(): Promise<void> {
    const subdomain = DomainResource.extractSubdomain();
    const data = subdomain ? { franchise_slug: subdomain } : { domain: DomainResource.getHostname() };
    const { response, success } = await ConfigManager.get(data);

    if (success && response?.data?.data) {
      setConfig(response.data.data);
    }

    company?.id && setTimeout(() => setLoading(false), 1000);
  }

  useEffect(() => {
    requestConfig();
  }, []);

  useEffect(() => {
    company?.id && setTimeout(() => setLoading(false), 1000);
  }, [company?.id]);

  const renderLoadingApp = () => (
    <AnimatePresence>{loading && <LoadingApp color={config?.primary_color} logo={config?.logo_url} />}</AnimatePresence>
  );

  const context = useMemo(
    () => ({
      loading,
      setLoading,
      renderLoadingApp,
    }),
    [loading, renderLoadingApp],
  );

  return (
    <LoadingContext.Provider value={context}>
      {children}
      {renderLoadingApp()}
    </LoadingContext.Provider>
  );
};

export default LoadingProvider;
